module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-content clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page-swipe"
  }, [_c('mt-swipe', {
    attrs: {
      "auto": 4000,
      "show-indicators": false
    }
  }, [_c('mt-swipe-item', {
    class: {
      slide1: true
    }
  }, [_c('a', {
    staticClass: "swipe-a",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": require("../../assets/1384.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', [_c('span', [_vm._v("￥" + _vm._s(_vm.data.data.price))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.data.data.title))])]), _vm._v(" "), _c('p', [_vm._v("不可思议的友谊奇迹，人生路上柔软的智慧之光")])])])]), _vm._v(" "), _c('mt-swipe-item', {
    class: {
      slide2: true
    }
  }, [_c('a', {
    staticClass: "swipe-a",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": require("../../assets/1324.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', [_c('span', [_vm._v("￥" + _vm._s(_vm.data.data2.price))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.data.data2.title))])]), _vm._v(" "), _c('p', [_vm._v("帕蒂·史密斯《只是孩子》姊妹篇，如何面对人生的不断失去...")])])])]), _vm._v(" "), _c('mt-swipe-item', {
    class: {
      slide3: true
    }
  }, [_c('a', {
    staticClass: "swipe-a",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": require("../../assets/898.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', [_c('span', [_vm._v("￥" + _vm._s(_vm.data.data3.price))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.data.data3.title))])]), _vm._v(" "), _c('p', [_vm._v("摄影教父阮义忠的少年画家梦，海外艺术家的海上访问记")])])])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h2', [_vm._v("豆瓣纸书")]), _vm._v(" "), _c('span', {
    staticClass: "fr cl"
  }, [_vm._v("更多")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8d16377e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/book/bookSwipe.vue
// module id = 61
// module chunks = 1